// extracted by mini-css-extract-plugin
module.exports = {"inputRow":"EnterGuardianInfo_inputRow__1u2po","errorMessage":"EnterGuardianInfo_errorMessage__x7_xM"};